import { __makeTemplateObject } from "tslib";
import { css, palette2 } from '../../../../foundation';
import { RcTabsClasses } from '../utils';
export var TabsStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: auto;\n\n    .", " {\n      background-color: ", ";\n    }\n  "], ["\n    min-height: auto;\n\n    .", " {\n      background-color: ", ";\n    }\n  "])), RcTabsClasses.indicator, palette2('tab', 'selected'));
};
var templateObject_1;
